import globalModule from "@/store/modules/global.module"
import RestClient from "../rest.client"
import { AxiosResponse } from "axios"

export default class UserService {
    static async updateAttributes(data: any) {
        await RestClient.call({
            url: '/users/attributes',
            method: 'put',
            headers: { 'Authorization': localStorage.getItem('token') },
            data
        })
            .then(async (response: AxiosResponse) => {
                console.log(response)
            })
            .catch((e) => {
                console.log(e)
            })
    }

} 